import React from 'react';
import { Helmet } from 'react-helmet';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { FaShoppingCart } from 'react-icons/fa';
import Styles from '../../styles/pages/sports-shoes.module.css';

const SportsShoes: React.FC = () => {
  // Function to handle button click
  const handleFirstButtonClick = () => {
    // Open the Amazon link in a new tab
    window.open('https://amzn.to/4e8hPqT', '_blank');
  };

  // Function to handle button click
  const handleSecButtonClick = () => {
    // Open the Amazon link in a new tab
    window.open('https://amzn.to/3RqUKGf', '_blank');
  };

  // Function to handle button click
  const handleThrdButtonClick = () => {
    // Open the Amazon link in a new tab
    window.open('https://amzn.to/3x559Rb', '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Sports Shoes - Mohit's Shopping App</title>
        <meta
          name="description"
          content="Explore top-quality sports shoes at Mohit's Shopping App. Discover a wide range of athletic footwear for running, training, and casual wear. Shop now for the best deals on sports shoes."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          property="og:title"
          content="Sports Shoes - Mohit's Shopping App"
        />
        <meta
          property="og:description"
          content="Find the best sports shoes at Mohit's Shopping App. Browse our selection of running shoes, training shoes, and casual sneakers for all activities."
        />
        <meta
          property="og:image"
          content={`${process.env.PUBLIC_URL}/favicon.png`} // Update the image path accordingly
        />
        <meta
          property="og:url"
          content="https://mohit-online-shopping.netlify.app/sports-spike-shoes"
        />
        <meta
          name="keywords"
          content="sports shoes, athletic footwear, running shoes, training shoes, casual sneakers, Mohit's Shopping App"
        />
      </Helmet>
      {/* Main Heading of the Home Page */}
      <h1 className="visually-hidden">
        Sports Shoes - Online Shopping App & Website
      </h1>
      {/* This is the First Section of Home Page */}
      <section>
        <Container>
          <Row>
            <Col xs={12} sm={12} md={6} className={Styles.column}>
              <div className={`${Styles.imgBox} ${Styles.firstDiv}`}>
                <img
                  src={`${process.env.PUBLIC_URL}/images/sports-shoes/frstsecone.png`}
                  alt="Prokick Turbo Running Spikes Shoes."
                  className={`${Styles.imageStyle} pointer`}
                />
                <img
                  src={`${process.env.PUBLIC_URL}/images/sports-shoes/frstsecsec.png`}
                  alt="Prokick Turbo Running Spikes Shoes."
                  className={`${Styles.imageStyle} pointer`}
                />
                <img
                  src={`${process.env.PUBLIC_URL}/images/sports-shoes/frstsecthrd.png`}
                  alt="Prokick Turbo Running Spikes Shoes."
                  className={`${Styles.imageStyle} pointer`}
                />
                <img
                  src={`${process.env.PUBLIC_URL}/images/sports-shoes/frstsecfrth.png`}
                  alt="Prokick Turbo Running Spikes Shoes."
                  className={`${Styles.imageStyle} pointer`}
                />
              </div>
            </Col>
            <Col xs={12} sm={12} md={6} className={Styles.firstColText}>
              <h2>Turbo Running Spikes</h2>
              <p className="">
                Prokick Turbo Running Spikes Shoes for Track and Field |
                Athletic Spikes Track & Field Shoes for Mens | TPU Sole with
                Mesh Upper | Removeable Spikes
                <hr />
                <span className="bold d-block mt-2">About this item</span>
              </p>
              <ul>
                <li>
                  Advanced Materials: Crafted with a blend of PU and Mesh in the
                  upper, these shoes provide a lightweight and breathable fit
                  essential for long races and sprints.{' '}
                </li>
                <li>
                  Customizable Traction: Equipped with an integrated TPU plate
                  and 8 removable metal spikes, the Turbo model allows for
                  customizable traction based on your specific event and surface
                  type.
                </li>
              </ul>
              <Button
                variant="outline-primary"
                onClick={handleFirstButtonClick}
              >
                Buy Now <FaShoppingCart style={{ marginLeft: '3px' }} />
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
      {/* This is the second Section of Home Page */}
      <section>
        <Container>
          <Row>
            <Col xs={12} sm={12} md={6} className={Styles.column}>
              <div className={`${Styles.imgBox} ${Styles.secDiv}`}>
                <img
                  src={`${process.env.PUBLIC_URL}/images/sports-shoes/secsecone.png`}
                  alt="Vector X Flyer Running Spike Shoe."
                  className={`${Styles.imageStyle} pointer`}
                />
                <img
                  src={`${process.env.PUBLIC_URL}/images/sports-shoes/secsecsec.png`}
                  alt="Vector X Flyer Running Spike Shoe."
                  className={`${Styles.imageStyle} pointer`}
                />
                <img
                  src={`${process.env.PUBLIC_URL}/images/sports-shoes/secsecthrd.png`}
                  alt="Vector X Flyer Running Spike Shoe."
                  className={`${Styles.imageStyle} pointer`}
                />
                <img
                  src={`${process.env.PUBLIC_URL}/images/sports-shoes/secsecfrth.png`}
                  alt="Vector X Flyer Running Spike Shoe."
                  className={`${Styles.imageStyle} pointer`}
                />
              </div>
            </Col>
            <Col xs={12} sm={12} md={6} className={Styles.firstColText}>
              <h2> X Flyer Running Spike</h2>
              <p className="">
                Vector X Flyer Running Spike Shoe for Men with Removeable Spike
                Black-Gold
                <hr />
                <span className="bold d-block mt-2">About this item</span>
              </p>
              <ul>
                <li>SHOE </li>
              </ul>
              <Button variant="outline-primary" onClick={handleSecButtonClick}>
                Buy Now <FaShoppingCart style={{ marginLeft: '3px' }} />
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
      {/* This is the Third Section of Home Page */}
      <section>
        <Container>
          <Row>
            <Col xs={12} sm={12} md={6} className={Styles.column}>
              <div className={`${Styles.imgBox} ${Styles.thrdDiv}`}>
                <img
                  src={`${process.env.PUBLIC_URL}/images/sports-shoes/thrdsecone.png`}
                  alt="Vector X Sprint Running Shoes (Black-Grey)."
                  className={`${Styles.imageStyle} pointer`}
                />
                <img
                  src={`${process.env.PUBLIC_URL}/images/sports-shoes/thrdsecsec.png`}
                  alt="Vector X Sprint Running Shoes (Black-Grey)."
                  className={`${Styles.imageStyle} pointer`}
                />
                <img
                  src={`${process.env.PUBLIC_URL}/images/sports-shoes/thrdsecthrd.png`}
                  alt="Vector X Sprint Running Shoes (Black-Grey)."
                  className={`${Styles.imageStyle} pointer`}
                />
                <img
                  src={`${process.env.PUBLIC_URL}/images/sports-shoes/thrdsecfrth.png`}
                  alt="Vector X Sprint Running Shoes (Black-Grey)."
                  className={`${Styles.imageStyle} pointer`}
                />
              </div>
            </Col>
            <Col xs={12} sm={12} md={6} className={Styles.firstColText}>
              <h2>X Sprint Running Shoes</h2>
              <p className="">
                Vector X Sprint Running Shoes (Black-Grey)
                <hr />
                <span className="bold d-block mt-2">About this item</span>
              </p>
              <ul>
                <li>TPU Plate and EVA Sole</li>
                <li>7 Metal Nails</li>
                <li>For All Age Groups </li>
                <li>Level- Intermediate</li>
              </ul>
              <Button variant="outline-primary" onClick={handleThrdButtonClick}>
                Buy Now <FaShoppingCart style={{ marginLeft: '3px' }} />
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SportsShoes;
